import React, { useContext, useEffect, useState } from "react";
import styles from './Header.module.css';
import { ReactComponent as Logo} from '../../imgs/Stratela_logo_white-1.svg';
import { ReactComponent as Burger } from '../../imgs/designStrat/two lines-27.svg'
import { ReactComponent as Cross } from '../../imgs/icons/cross-33.svg'
import { NavLink, useNavigate } from "react-router-dom";
import { HeaderContext } from "../contextProviders/AlertContext";

export default function Header({navigateToElement}){

    const navigate = useNavigate();

    const [mobileVersion,setMobileVersion] = useState(true);
    const [navBarShow,setNavBarShow] = useState(false);
    const [headerColor,setHeaderColor] = useState(false);
    const [lightTheme,setLightTheme] = useState();
    const [headerPos,setHeaderPos] = useState(0);
    const [theme,setTheme] = useState('headerColorOffWhite');
    const [textTheme,setTextTheme] = useState('headerTextBlack');
    const [layoutTheme,setLayoutTheme]= useState('');

    const {minimisedHeader} = useContext(HeaderContext);

    const toggleNavBar = () => {
        setNavBarShow((prev) => !prev);
    }
    
    const onResizeFunction = () => {
        const newViewportWidth = window.innerWidth;
        setMobileVersion(newViewportWidth < 900);
        setNavBarShow(newViewportWidth > 900);
        console.log(window.scrollY);
    }

    const onScrollFunction = () => {
        if(window.scrollY === 0){
            setLayoutTheme('');
            setTheme('headerColorOffWhite');
        } else {
            setTheme('headerColorClear');
            setLayoutTheme('scrolled');
        }
    }

    useEffect(() => {
        onResizeFunction();
        window.addEventListener('resize', onResizeFunction);
        window.addEventListener('scroll', onScrollFunction);
        return () => {
            window.removeEventListener('resize', onResizeFunction);
            window.removeEventListener('scroll', onScrollFunction);
        }
    },[]);

    useEffect(() => {
        onScrollFunction();
        // if(window.location.pathname.includes('/contact')){
        //     switchTheme('#d4e3f5','#0f1d25');
        // } else if (window.location.pathname.includes('/home') || window.location.pathname.includes('/aboutUs')){
        //     switchTheme('#0f1d25','#0f1d25');
        // }
    },[window.location.pathname])
    
    const handleLogoClick = () => {
        // window.scrollTo(0,0);
        navigateToElement('/home','');
    }

    const handleNavClick = (text) => {
        window.scrollTo(0,0);
        if(mobileVersion){
            setNavBarShow(false);
        }
        // if(text){
        //     if(text.includes('/contact')){
        //         switchTheme('#d4e3f5','#0f1d25');
        //     } else if (text.includes('/home') || text.includes('/aboutUs')){
        //        switchTheme('#0f1d25','#0f1d25');
        //     }
        // }
    }

    const switchTheme = (themeColor,bodyBackground) => {
        document.body.style.backgroundColor = bodyBackground;
        document.documentElement.style.background = bodyBackground;
        setThemeColor(themeColor)
    }

    const setThemeColor = (color) => {
        document.querySelectorAll('meta[name="theme-color"]').forEach((tag) =>
            tag.remove()
        );
        const meta = document.createElement("meta");
        meta.name = "theme-color";
        meta.content = color;
        requestAnimationFrame(() => {
            document.head.appendChild(meta);
        });
    }

    const navigateAndClose = (pagePath,sectionId) => {
        navigateToElement(pagePath,sectionId);
        if(mobileVersion){
            setNavBarShow(false);
        }
    }

    return (
        <header style={{top: headerPos}} className={`${styles[theme]} ${styles[textTheme]} ${styles[layoutTheme]} ${minimisedHeader? styles.minimised : ''} ${navBarShow? styles.showWhileMini : ''}`}>
           <div className={styles.innerContainer}>
               <div className={styles.imgContainer} onClick={handleLogoClick}>
                    <Logo />
               </div>
               <div className={styles.navigateTop} onClick={() => window.scrollTo(0,0)}>

                </div>
               <div className={`${styles.burgerMenuButton} ${mobileVersion? styles.displayGrid: styles.hide}`} onClick={toggleNavBar}>
                    {navBarShow? <Cross /> : <Burger />}
               </div>
               <nav className={`${navBarShow? styles.displayBlock : ''}`}>
                    <ul>
                        <li>
                            <a onClick={() => navigateAndClose('/home','aboutUsSection')}>About Us</a>
                        </li>
                        <li>
                            <a onClick={() => navigateAndClose('/home','ourWorkSection')}>Our Work</a>
                        </li>
                        <li>
                            <a onClick={() => navigateAndClose('/contact','')}>Contact Us</a>
                        </li>
                    </ul>
               </nav>
           </div>
        </header>
    )
}